import api from "@/services/api";
import { getRoleBasedEndpoint } from "@/services/apiHelper"; // Import helper

const getPolyclinicsEndpoint = () => {
  return getRoleBasedEndpoint("polyclinics");
};

// Get polyclinics
export const getPolyclinics = async (
  page,
  perPage,
  sortBy = "id.asc",
  searchQuery = "",
  hasQuestionerGroup = null, // Add this parameter
  id = null // Add id parameter to fetch specific polyclinic
) => {
  try {
    const params = {
      sortBy,
      page,
      perPage,
      search: searchQuery,
    };

    if (hasQuestionerGroup !== null) {
      params.hasQuestionerGroup = hasQuestionerGroup;
    }
    if (id !== null) {
      params.id = id;
    }

    const response = await api.get("/v1/admin/polyclinics", {
      params,
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching polyclinics:", error);
    throw error;
  }
};

// Get polyclinic by ID
export const getPolyclinicById = async (id) => {
  try {
    const endpoint = getPolyclinicsEndpoint();
    const response = await api.get(`${endpoint}/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching polyclinic:", error);
    throw error;
  }
};

// Create polyclinic
// In services/admin/polyclinics.js
export const createPolyclinic = async (polyclinicData) => {
  try {
    const endpoint = getPolyclinicsEndpoint();
    if (
      typeof polyclinicData.icon === "string" &&
      polyclinicData.icon.startsWith("http")
    ) {
      const response = await api.post(endpoint, polyclinicData);
      return response.data;
    } else {
      const formData = new FormData();
      Object.keys(polyclinicData).forEach((key) => {
        if (polyclinicData[key] !== null && polyclinicData[key] !== undefined) {
          formData.append(key, polyclinicData[key]);
        }
      });

      const response = await api.post(endpoint, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      return response.data;
    }
  } catch (error) {
    console.error("Error creating polyclinic:", error);
    if (error.response) {
      console.error("Server response:", error.response.data);
      console.error("Status code:", error.response.status);
    }
    throw error;
  }
};
export const updatePolyclinic = async (id, polyclinicData) => {
  try {
    console.log("Updating polyclinic with data:", polyclinicData);
    const endpoint = getPolyclinicsEndpoint();

    const formData = new FormData();
    Object.keys(polyclinicData).forEach((key) => {
      if (polyclinicData[key] !== null && polyclinicData[key] !== undefined) {
        formData.append(key, polyclinicData[key]);
      }
    });

    const response = await api.put(`${endpoint}/${id}`, formData);
    return response.data;
  } catch (error) {
    console.error("Error updating polyclinic:", error);
    throw error;
  }
};

// Delete polyclinic
export const deletePolyclinic = async (id) => {
  try {
    const endpoint = getPolyclinicsEndpoint();
    await api.delete(`${endpoint}/${id}`);
    return id;
  } catch (error) {
    console.error("Error deleting polyclinic:", error);
    throw error;
  }
};
